import { broadcast, Broadcast, BroadcastTarget } from '.'

export function broadcastResponse<E extends string, T = any>(
  source: Window | MessagePort | ServiceWorker | null,
  config: Broadcast<E, T>,
  originalTarget: BroadcastTarget
) {
  if (typeof source?.postMessage === 'function') {
    ;(source as Window).postMessage(JSON.stringify(config), '*')
    return
  }

  broadcast(originalTarget, config)
}
